import src from "IMAGE";
export default { src, width: 130, height: 33, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAUFB1oFBQZUAwMDMAQEBS0EBAUoAwMEIwQEBCQDAwQoAAoKDGALCgxaBQUGNQkICkELCgtFCgkLQwsKC0IJCQpBmnkFKPbji9sAAAAASUVORK5CYII="};
